// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qf-6";
export var imgContainer = "_qf-3";
export var menuIcon = "_qf-5";
export var pillWrapper = "_qf-2";
export var pillsContainer = "_qf-1";
export var subscriptionCard = "_qf-0";
export var subscriptionLogo = "_qf-4";